jQuery(document).ready(function ($) {

    // $('.blends-grid').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   dots: false,
    //   infinite: true,
    //   mobileFirst: true,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: 'unslick'
    //     }
    //   ]
    // });

  /*function applyDiscountCode(discountCode) {
      // Step 1: Apply discount code
      fetch(`/discount/${discountCode}`)
          .then(function(response) {
              if (!response.ok) {
                  throw new Error(`Failed to apply discount code: ${response.statusText}`);
              }
              // Step 2: Force cart update after discount is applied
              return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                      updates: {}, // Optional: You can pass the updated cart details here if necessary
                  }),
              });
          })
          .then(function(cartResponse) {
              if (cartResponse.ok) {
                  console.log(`✅ Discount code ${discountCode} applied successfully and cart updated.`);
              } else {
                  throw new Error(`Failed to update cart: ${cartResponse.statusText}`);
              }
          })
          .catch(function(error) {
              console.error('Error:', error);
          });
  }

// Example usage: Apply the discount and go to checkout
applyDiscountCode('LEGEND3PACK');*/

  $('.coffee-scrollable-text__slider').slick({
    vertical: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1200,
    arrows: false,
    dots: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    swipe: false
  });

  // $('section.slideshow').on( 'change.flickity', function( event, index ) {
  //     console.log( 'Slide changed to ' + index )
  //   });

  function adjustImageWrapperHeight() {
    const imageWrapper = document.querySelector('.slideshow-slide__image-wrapper');
    const contentWrapper = document.querySelector('.slideshow-slide__content--slide-1');

    // Check the viewport width
    if (window.innerWidth <= 859) {
      // Calculate the height of the content wrapper + 2rem (added space)
      const contentHeight = contentWrapper.offsetHeight;
      const additionalHeight = 2 * parseFloat(getComputedStyle(document.documentElement).fontSize); // 2rem in px
      imageWrapper.style.height = `${contentHeight + additionalHeight}px`;
    } else {
      // Reset the height for larger screens (if needed)
      imageWrapper.style.removeProperty('height');
    }
  }

  // Call the function initially
  adjustImageWrapperHeight();

  // Add an event listener to trigger on window resize
  window.addEventListener('load', adjustImageWrapperHeight);
  window.addEventListener('resize', adjustImageWrapperHeight);




  




});

